<template>
    <n-message-provider :duration="30000" :max="1">
        <router-view />
    </n-message-provider>
</template>
<script lang="ts" setup>
import { NMessageProvider } from "naive-ui";
</script>
<style>
.app {
    height: 100vh;
    background-color: #f8f8fb;
}
</style>
